import { PATHS } from './config';

export interface ILegacyRedirect {
  from: PATHS;
  to: PATHS;
}

/**
 * Старые карьерные адреса → новые (ТЗ 0069).
 *
 * Один массив, а не восемь `<Navigate>` вразнобой по `AppRouter`: весь список
 * должен проверяться глазами за пять секунд. Ссылки из писем, закладок и
 * заметок живут вечно — срока снятия у этого списка нет.
 *
 * Параметрические строки (`:code`, `:slug`) подставляет `LegacyRedirect`:
 * `<Navigate>` в react-router 6.2 параметры НЕ подставляет и увёл бы человека
 * на литеральный `/career/skills/:slug`.
 */
export const LEGACY_REDIRECTS: ILegacyRedirect[] = [
  { from: PATHS.legacyResume, to: PATHS.careerProfile },
  { from: PATHS.legacyGrowthAchievements, to: PATHS.careerAchievements },
  { from: PATHS.legacyGrowthProfession, to: PATHS.careerProfession },
  { from: PATHS.legacyGrowthProfessions, to: PATHS.careerProfessions },
  { from: PATHS.legacyGrowthSkill, to: PATHS.careerSkill },
  { from: PATHS.legacyGrowthSkills, to: PATHS.careerSkills },
  { from: PATHS.legacyGrowth, to: PATHS.careerCenter },
  { from: PATHS.legacyCareerVacancies, to: PATHS.careerJobs },
];
